import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({
    url: '/demon/draw/init',
    method: 'GET',
    params: { ...params, app_id: 67 }
  }, { interceptResultCode: false });
};

// 抽奖
export const lottery = (params) => {
  return axios({
    url: '/demon/draw/lottery',
    method: 'POST',
    params: { ...params, app_id: 67 }
  }, { interceptResultCode: false });
};

// 帮助页初始化
export const onGetInitHlepDataAPI = (params) => {
  return axios({
    url: '/demon/draw/help',
    method: 'GET',
    params: { ...params, app_id: 67 }
  }, { interceptResultCode: false });
};

// 助力
export const help = (params) => {
  return axios({
    url: '/demon/draw/help',
    method: 'POST',
    params: { ...params, app_id: 67 }
  }, { interceptResultCode: false });
};

// 下载地址
export const onDownloadApi = (params) => {
  return axios({ url: '/get_url?game_id=67', method: 'GET', params }, { interceptResultCode: false });
};

// 免密登录
export const onAutoLoginAPI = (data) => {
  return axios({ url: '/game/clock/login', method: 'POST', data }, { interceptResultCode: false });
};

// 支付
export const onPayAPI = (data) => {
  return axios({ url: '/game/clock/pay', method: 'POST', data });
};

// 订单查询
export const onQueryOrderAPI = (params) => {
  return axios({ url: '/game/clock/show', method: 'GET', params }, { interceptResultCode: false });
};

// 退款
export const onRefundAPI = (params) => {
  return axios({ url: '/game/clock/refund', method: 'GET', params });
};

// 获取打卡信息
export const getCardInfoAPI = (params) => {
  return axios({ url: '/game/clock/sing', method: 'GET', params });
};

// codeId查询api
export const wechatInfoAPI = (params) => {
  return axios({ url: '/wechat/info', method: 'GET', params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/servitor/anniversary/api.js